import {RepositoryFactory} from '@/repository/RepositoryFactory';

const NotificationRepository = RepositoryFactory.get('notification');

export default {
  state: {
    notifications: [],
  },
  mutations: {
    SET_NOTIFICATIONS: (state, notifications) => {
      state.notifications = notifications
    },
  },
  getters: {
    notifications: state => state.notifications,
  },
  actions: {
    async fetchNotifications({ commit }, isUnread) {
      if(isUnread) {
        const { data } = (await NotificationRepository.getUnreadNotifications()).data
        commit('SET_NOTIFICATIONS', data );
      } else {
        const { data } = (await NotificationRepository.getAllNotifications()).data
        commit('SET_NOTIFICATIONS', data );
      }
    },
    async markAsReadNotification({commit, dispatch}, {id, showOnlyUnread}) {
      await NotificationRepository.notificationMarkAsRead(id)
      dispatch('fetchNotifications', showOnlyUnread)
    },
    async markAsUnReadNotification({commit, dispatch}, {id, showOnlyUnread}) {
      await NotificationRepository.notificationMarkAsUnRead(id)
      dispatch('fetchNotifications', showOnlyUnread)
    },
    async markAllAsReadNotification({commit, dispatch}) {
      await NotificationRepository.notificationMarkAllAsRead()
      dispatch('fetchNotifications', false)
    },
  }
}
